import { LoadState } from "../../constants/enums";


export interface ICompanyInformationState {
  data: ICompanyInformation;
  loading: LoadState;
  error: string;
}

export interface ICompanyInformation {
  company_id: string | null;
  company_name: string | null;
  address: string | null;
  unit_or_suite: string | null;
  city: string | null;
  province_or_state: string | null;
  postal_code: string | null;
  country: string | null;
  phone: string | null;
  telephone: string | null;
  fax: string | null;
  default_language: string | null;
  logo: string | null;
  fav_icon: string | null;
  status: string;
}

export const initialCompanyInformation: ICompanyInformationState = {
    data: {
        company_id: "1",
        company_name: null,
        address: null,
        unit_or_suite: null,
        city: null,
        province_or_state: null,
        postal_code: null,
        country: null,
        phone: null,
        telephone: null,
        fax: null,
        default_language: null,
        // email: null,
      
        logo: null,
        fav_icon: null,
        status: "",
    },
    loading: LoadState.NotLoaded,
    error: "",
}
